import { render, staticRenderFns } from "./main.unidadContenido.vue?vue&type=template&id=5b58a054"
import script from "./main.unidadContenido.vue?vue&type=script&lang=js"
export * from "./main.unidadContenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports